import React, { useState, useEffect, useRef } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { Alert, Form } from 'react-bootstrap'

const CustomCheckboxOptionModal = (props) => {
  const [customName, setCustomName] = useState(props.formValue || '')

  const formRef = useRef()

  useEffect(() => {
    if (formRef && formRef.current) {
      formRef.current.focus()
    }
  })

  const handleConfirm = () => {
    if (!customName) {
      return props.toggleAlertMessage(`Please enter a name for the ${props.modelName.toLowerCase()} before saving.`)
    }
    if (props.onConfirmPatch && props.onConfirmMethod && props.onConfirmMethod.toLowerCase() === 'patch') {
      return props.onConfirmPatch(customName)
    }
    return props.onConfirm(customName)
  }

  const handleCancel = () => {
    if (props.showAlertMessage) {
      props.toggleAlertMessage('')
    }
    return props.onCancel()
  }

	return (
		<Modal
			dialogClassName="modal-wide"
			show={props.show}
      onHide={handleCancel}
		>
			<Modal.Header closeButton>
				{props.headerText}
			</Modal.Header>

			<Modal.Body>
        {props.showAlertMessage ?
          <Alert
            variant="danger"
            dismissible
            onClose={() => props.toggleAlertMessage('')}
          >
            <Alert.Heading>
              Error adding {props.modelName.toLowerCase()} option
            </Alert.Heading>
            <p>
              {props.alertMessage}
            </p>
          </Alert>
          :
          null
        }

				{props.bodyText ?
          <p>
            {props.bodyText}
          </p>
          :
          null
        }

        <Form.Control
          // id={`${option.fieldName}-${textField.fieldName}`}
          ref={formRef}
          className='text-option-checkbox-form'
          value={customName}
          onChange={(e) => setCustomName(e.target.value)}
          placeholder={props.formPlaceholder}
          required={true}
          disabled={props.disabled}
        />
			</Modal.Body>

			<Modal.Footer>
				{props.hideConfirmButton ?
					null
					:
					<Button onClick={handleConfirm} variant="primary">
						{props.confirmText || 'Save'}
					</Button>
				}

				{props.hideCancelButton ?
					null
					:
          <Button onClick={handleCancel} variant="secondary">
						{props.cancelText || 'Cancel'}
					</Button>
				}
			</Modal.Footer>
		</Modal>
	)
}

export default CustomCheckboxOptionModal